import { render } from "./add-delivery-challans.vue?vue&type=template&id=48d9e725"
import script from "./add-delivery-challans.vue?vue&type=script&lang=js"
export * from "./add-delivery-challans.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__